import styled from 'styled-components';
import { Type, mobileViola, screenSmMax } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../Animations';
export const Eyebrow = withAnimationContext(styled(Type.h6).attrs({
    variant: 'ballad',
    className: 'eyebrow',
}) `
  ${fadeInAnimation(DELAYS.FIRST)};
  text-align: ${({ centered }) => (centered ? 'center' : 'start')};
  text-transform: uppercase;
  font-weight: 450;
  line-height: 24px;

  @media (max-width: ${screenSmMax}) {
    ${() => mobileViola}
    /* MAYBE REMOVE CHECK WITH @dom-squad-designers */
    line-height: 21px;
    font-weight: 450;
    /** */
  }
`);
//# sourceMappingURL=Eyebrow.js.map